import React, { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

export default function DateRangePicker({ onValueChange }) {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  const handleChangeStart = (date) => {
    setStartDate(date);
    onValueChange([date, endDate]);
  };

  const handleChangeEnd = (date) => {
    setEndDate(date);
    onValueChange([startDate, date]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer
        components={["DatePicker", "DatePicker"]}
        sx={{ paddingTop: "10px" }}
      >
        <DatePicker
          label="Date:From"
          value={startDate}
          onChange={handleChangeStart}
        />
        <DatePicker
          label="Date:To"
          value={endDate}
          onChange={handleChangeEnd}
        />
      </DemoContainer>
    </LocalizationProvider>
  );
}
